import React, { Fragment } from "react";
import { Text, Field, ButtonLink, Button } from "../styles/form-step-styles";

const Step2 = () => (
  <Fragment>
    <Text className="animated fadeInLeft delay-2">
      {
        "That's your account setup. Now let's finish uploading your job. Click that big pink button below to continue, alternatively give us a call and we can help you get started."
      }
    </Text>
    <Field className="animated fadeInUp delay-4">
      <ButtonLink
        data-test-id="employer_registration_finish_button"
        title="Finish posting job"
        href="/employer/dashboard"
      >
        <Button>Finish posting job</Button>
      </ButtonLink>
    </Field>
    <Text>Or call: 0161 300 7235</Text>
  </Fragment>
);

export default Step2;
